import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Box
} from "@mui/material";
import { Warning as WarningIcon } from "@mui/icons-material";
import { t as coachT } from "../dashboard/coach/coachTokens";

const DeleteFormDialog = ({ open, onClose, onConfirm, formTitle, coach = false }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="delete-form-dialog-title"
            aria-describedby="delete-form-dialog-description"
            PaperProps={{
                sx: {
                    borderRadius: coach ? coachT.r : "12px",
                    minWidth: "320px",
                    direction: "rtl"
                }
            }}
        >
            <DialogContent sx={{ textAlign: "center", padding: "32px 24px 16px" }}>
                <Box
                    sx={{
                        width: 64,
                        height: 64,
                        borderRadius: "50%",
                        backgroundColor: coach ? coachT.redLight : "#FEE2E2",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "0 auto 16px"
                    }}
                >
                    <WarningIcon sx={{ fontSize: 32, color: coach ? coachT.red : "#EF4444" }} />
                </Box>
                <DialogTitle
                    id="delete-form-dialog-title"
                    sx={{
                        padding: 0,
                        marginBottom: "8px",
                        fontWeight: coach ? 800 : 600,
                        fontSize: "18px",
                        color: coach ? coachT.text : "#1E293B",
                        fontFamily: '"Heebo", "Roboto", sans-serif'
                    }}
                >
                    האם אתה בטוח?
                </DialogTitle>
                <DialogContentText
                    id="delete-form-dialog-description"
                    sx={{
                        color: "#64748B",
                        fontSize: "14px",
                        fontFamily: '"Heebo", "Roboto", sans-serif'
                    }}
                >
                    {formTitle
                        ? `אתה עומד למחוק את הטופס "${formTitle}". פעולה זו לא ניתנת לביטול.`
                        : "אתה בטוח רוצה למחוק את הטופס? פעולה זו לא ניתנת לביטול."
                    }
                </DialogContentText>
            </DialogContent>
            <DialogActions
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "16px 24px 24px",
                    gap: 1
                }}
            >
                <Button
                    variant="outlined"
                    onClick={onClose}
                    sx={{
                        borderColor: coach ? coachT.border : "#E2E8F0",
                        color: coach ? coachT.t2 : "#64748B",
                        borderRadius: coach ? coachT.rs : undefined,
                        fontFamily: '"Heebo", "Roboto", sans-serif',
                        "&:hover": {
                            borderColor: coach ? coachT.t3 : "#CBD5E1",
                            backgroundColor: coach ? coachT.bg : "#F8FAFC"
                        }
                    }}
                >
                    ביטול
                </Button>
                <Button
                    variant="contained"
                    onClick={onConfirm}
                    sx={{
                        backgroundColor: coach ? coachT.red : "#EF4444",
                        borderRadius: coach ? coachT.rs : undefined,
                        boxShadow: coach ? "none" : undefined,
                        fontFamily: '"Heebo", "Roboto", sans-serif',
                        "&:hover": {
                            backgroundColor: coach ? coachT.redText : "#DC2626",
                            boxShadow: coach ? "none" : undefined
                        }
                    }}
                >
                    מחק
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteFormDialog;
